/* global OpenBadges */

function index(coursenum) {
  $('.analytics_knob > input').knob({
    readOnly: true,
    format: function (v) {
      return v + '%'
    },
  })

  $('td.popup_column')
    .off('click.popup_column')
    .on('click.popup_column', function () {
      var td = $(this)
      $.meDialog.open2({
        id: 'analytics-modal',
        url: td.attr('data-modal-url'),
        title: td.attr('data-modal-title'),
        width: '800px',
      })
    })

  $('#earned_badges')
    .find('.badge_container')
    .each(function () {
      var container = $(this)
      container.popover({
        html: true,
        content: container.find('.badge_popover').html(),
        placement: 'top',
        trigger: 'click',
      })
    })

  /* Enable the post to mozilla OpenBadges */
  $('#earned_badges')
    .off('click', '.post_openbadges_button')
    .on('click', '.post_openbadges_button', function () {
      var guid = $(this).attr('data-eb-guid')
      OpenBadges.issue([
        `https://app.myeducator.com/account/badge.assertion/${coursenum}/${guid}`,
      ])
    })
}

function video(coursenum, studentId) {
  $('.analytics_detail_table')
    .find('.video_icon > .icon')
    .each(function () {
      var popover = $(this).closest('.video_icon').find('.video_icon_popover')
      $(this).popover({
        html: true,
        content: popover.html(),
        trigger: 'hover',
        placement: 'left',
      })

      $(this)
        .off('click.video_icon')
        .on('click.video_icon', function () {
          $.meDialog.open2({
            id: 'video_details_extra',
            url: `/course/progress.video_detail_extra/${coursenum}/${studentId}/`,
            width: 800,
            title: 'Plays of this Video',
            ajax: {
              data: {
                vhs: popover.attr('data-vhs'),
                fileref: popover.attr('data-fileref'),
              },
              type: 'POST',
            },
          })
        })
    })
}

function reading(coursenum, studentId) {
  $('.analytics_detail_table')
    .find('.paragraph_icon > .icon')
    .each(function () {
      var popover = $(this)
        .closest('.paragraph_icon')
        .find('.paragraph_icon_popover')
      $(this).popover({
        html: true,
        content: popover.html(),
        trigger: 'hover',
        placement: 'left',
      })

      $(this)
        .off('click.paragraph_icon')
        .on('click.paragraph_icon', function () {
          var allParas = []
          popover
            .closest('.reading_detail_column')
            .find('.paragraph_icon')
            .each(function () {
              allParas.push($(this).attr('data-para'))
            })

          $.meDialog.open2({
            id: 'reading_details_extra',
            url: `/course/progress.reading_detail_extra/${coursenum}/${studentId}/`,
            width: 800,
            title: 'Views of this Paragraph',
            ajax: {
              data: {
                rhs: popover.attr('data-rhs'),
                para: popover.attr('data-para'),
                allParas: allParas.join(','),
              },
              type: 'POST',
            },
          })
        })
    })
}

export var LegacyCourseProgress = { index, video, reading }
